import { render } from "./Step3DisplayMessage.vue?vue&type=template&id=6e1370ab"
import script from "./Step3DisplayMessage.vue?vue&type=script&lang=js"
export * from "./Step3DisplayMessage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__